export enum LicenseType {
  PRIVATE_CAR = 'PRIVATE_CAR',
  PUBLIC_TRANSPORTER = 'PUBLIC_TRANSPORTER',
  PRIVATE_TRANSPORTER = 'PRIVATE_TRANSPORTER',
  PUBLIC_MINIBUS = 'PUBLIC_MINIBUS',
  PRIVATE_MINIBUS = 'PRIVATE_MINIBUS',
  TAXI = 'TAXI',
  HEAVY_EQUIPMENT_PUBLIC_WORKS = 'HEAVY_EQUIPMENT_PUBLIC_WORKS',
  EXPORT = 'EXPORT',
  DIPLOMATIC = 'DIPLOMATIC',
  MOTORCYCLE = 'MOTORCYCLE',
  TEMPORARY = 'TEMPORARY'
}
